import { lazy } from 'react';

export const ObjectServicePageLazy = lazy(() => import('./ObjectServicePage'));
